import * as models from './models';
import * as object from './object';

export function IsQuoteLineItem(v: unknown): v is models.QuoteLineItem {
    return object.IsObject(v) && (
        object.HasKey(v, 'quoteID') ||
        object.HasKey(v, 'quoteProofID') ||
        object.HasKey(v, 'quoteProof') ||
        object.HasKey(v, 'quoteChildLineItems')
    );
}